import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import swal from "sweetalert2";
// import { MainService } from "../../service/main.service";
import { SettingService } from "../../service/setting.service";
import { WorkService } from "../../service/work.service";
import { HierarchyService } from "../../service/hierarchy.service";
import { DataControlService } from '../../service/data-control.service'
import { LedgerService } from '../../service/ledger.service';
declare let $: any;
import { MatPaginator } from '@angular/material/paginator';
import { session } from '../../../../environments/environment.session'
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LogService } from '../../../portal/service/log.service';
import { EditorService } from "../../../md/service/editor.service";
import { ApprovalUserService } from '../../../portal/service/approval-user.service';
// import { MainService as mainserviceEmb } from '../../../emb/service/main.service';
import { ToastrService } from 'ngx-toastr';
import { MainService as PoralMainService } from "../../../portal/service/main.service";
import { ProcessDocumentPrintService } from "../../service/process-document-print.service";
// import { FileService as ComputerFileService } from "../../../computer/service/file.service";
// import { FileService as StmFileService } from '../../../stm/service/file.service'
import { MainService as MdMainService } from "../../../md/service/main.service";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts"
import { Utf8EncodingService } from "src/app/md/service/utf8-encoding.service";
// (pdfMake as any).vfs = pdfFonts.vfs;
@Component({
  selector: "app-work",
  templateUrl: "./work.component.html",
  styleUrls: ["./work.component.css"],
})
export class WorkComponent implements OnInit {
  sortCol: any;
  is_loggedIn_role_is_FAO: boolean = false;
  constructor(
    private hierarchyService: HierarchyService,
    private settingService: SettingService,
    private workS: WorkService,
    private spinner: NgxSpinnerService,
    private dataControlService: DataControlService,
    private ledgerService: LedgerService,
    private log: LogService,
    private editorService: EditorService,
    public ApprovalUserService: ApprovalUserService,
    private toastr: ToastrService,private utf8EncodingService:Utf8EncodingService,
    // private mainserviceEmb: mainserviceEmb,
    private poralMainService: PoralMainService,
    private processDocumentPrintService: ProcessDocumentPrintService,
    // private computerFileService: ComputerFileService,
    // private stmFileService: StmFileService,
    private mdMainService:MdMainService

  ) {
    this.obj = { prod_cd: "", act_cd: "", proj_cd: "", bud_cd: "" };
  }


  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  @ViewChild('resetSub') subreset!: ElementRef<HTMLButtonElement>;
  @ViewChild('hiereset') hiereset!: ElementRef<HTMLButtonElement>;
  @ViewChild('resetUpdate') resetUpdate!: ElementRef<HTMLButtonElement>;


  datasource = new MatTableDataSource();

  obj: any = { prod_cd: "", act_cd: "", proj_cd: "", bud_cd: "" };
  displayedColumns: any = []
  all_module_displayedColumns = ["work_id", "work_order_no", "work_desc", "work_start_dt", "work_order_amt", "le_id", "module_cd", 'status', "action",];
  module_displayedColumns = ["work_id", "work_order_no", "work_desc", "work_start_dt", "work_order_amt", "le_id", 'status', "action"];//remved module code
  displayedColumnsObj: any = { work_id: 'File ID', work_order_no: 'File Number', work_desc: 'File Description', work_start_dt: 'Work Order Start Date', work_order_amt: 'File Amount', le_id: 'Assigned To', status: 'Status', module_cd: 'Module Code', action: 'Action' }
  allWorkdisplayedColumns = ["work_id", "work_order_no", "work_desc", "work_start_dt", "work_order_amt", "module_cd", 'status', "le_id",];
  erpUser: any
  user_id: any;
  b_acct_id: any
  allSal = [];

  allProjectHier: any = [];
  allProductHier: any = [];
  allActivityHier: any = [];
  allBudgetHier: any = [];
  logObj: any = { component: 'WORK' }
  allBudget: any = [];
  allProject: any = [];
  allProduct: any = [];
  allActivity: any = [];
  view_details: any = false;
  techToBusNameObj: any = {};
  create_flag: any = false;
  allWork_flage: any = false;
  all_list_flag: boolean = true;
  activeTab: string = 'all'

  update_flag: any = false;
  max_amt_fg: boolean = false;
  datasourceWork = new MatTableDataSource();

  additional_document: any = [{ file_name: null, file: null }]

  async ngOnInit() {
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.b_acct_id = this.erpUser.b_acct_id
    this.user_id = this.erpUser.user_id;
    await this.getActiveFinYear();
    await this.getVendors();
    await this.getModuleUser();
    await this.getAllBudget();
    await this.getAllProject();
    await this.getAllProduct();
    await this.getAllActivity();
    await this.currentDate();
    await this.getAllModuleWork('all');
    this.is_loggedIn_role_is_FAO = this.erpUser.role_cd.includes('FAO')
  }

  addAdditionalDoc() {
    this.additional_document.push({ file_name: null, file: null, show_file_name_on_update: true })
  }

  removeAdditionalDoc(i: number) {
    this.additional_document.splice(i, 1)
  }


  current_date: any;
  async currentDate() {
    let date = new Date();
    let d = date.getDate()
    let d1;
    if (d < 10) {
      d1 = '0' + d;
    } else {
      d1 = d;
    }

    let m = date.getMonth() + 1;
    let m1;
    if (m < 10) {
      m1 = '0' + m;
    } else {
      m1 = m;
    }

    let y = date.getFullYear();

    this.current_date = y + '-' + m1 + '-' + d1;
  }

  timedOutCloser: any;
  targetMenuTrigger: any;
  mouseEnter(trigger: any) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  mouseLeave(trigger: any) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }


  async createNew() {
    this.create_flag = true;
    this.all_list_flag = false;
    this.update_flag = false;
    this.allWork_flage = false;
    this.view_details = false;
    this.refresh()
    this.subreset.nativeElement.click();
    this.hiereset.nativeElement.click()
    this.additional_document = [{ file_name: null, file: null }]

  }
  async allWorkList(activeTab: string) {
    this.activeTab = activeTab
    this.refresh();
    this.create_flag = false;
    this.all_list_flag = false;
    this.update_flag = false;
    this.allWork_flage = true;
    this.view_details = false;
    await this.getAllAccountWork('unAuth');
  }





  // all_vendor = []
  all_party: any = [];
  vendorPANObj: any = {}
  async getVendors() {
    this.spinner.show()
    var resp = await this.settingService.getAllVendors();
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "ALL VENDORS LIST RECEIVED SUCCESSFULLY" })


      this.all_party = resp.data;
      resp['data'].map((x: any) => {

        this.vendorPANObj[x['le_id']] = x['partner_pan_no']
      });
      this.spinner.hide()
    }else{
      this.spinner.hide()
    }
  }
  AllPartyObj: any = {}
  parties: any = []
  async getModuleUser() {
    this.spinner.show();
    let obj: any = {}
    obj["module_cd"] = 'ACCOUNT';
    obj['b_acct_id'] = this.b_acct_id
    var resp = await this.mdMainService.getModuleUser(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "ESTABLISHED EMPLOYEE LIST RECEIVED SUCCESSFULLY" })
      this.parties = resp.data;

      this.parties.map((x: any) => {
        this.AllPartyObj[x['le_id']] = x['emp_name']
      })
      this.spinner.hide();

    }else{
      this.spinner.hide()
    }
  }

  setPartyDetails() {
    if (this.obj["party_le_id"]) {
      for (let i = 0; i < this.all_party.length; i++) {
        if (this.obj["party_le_id"] == this.all_party[i]["le_id"]) {
          this.obj["party_phone_no"] = this.all_party[i]["mobile_no"];
          this.obj["party_gstin_no"] = this.all_party[i]["gst_no"];
          this.obj["party_email"] = this.all_party[i]["email"];
          break;
        }
      }
    } else {
      this.obj["party_phone_no"] = null
      this.obj["party_gstin_no"] = null
      this.obj["party_email"] = null
    }
  }

  async addWorkInProjectHier(work_id: any) {
    let level = 0;
    let obb: any = new Object();
    let isError = false;
    this.allProjectHier.map((x: any) => {
      if (this.obj["proj_cd"] == x["leaf_cd"]) {
        for (let i = 1; i < 8; i++) {
          if (x["lvl" + i + "_cd"] == x["leaf_cd"]) {
            level = i;
          }
        }
        obb = Object.assign({}, x);
      }
    });

    obb["b_acct_id"] = this.b_acct_id;

    obb["lvl" + (level + 1) + "_user_cd"] = "ACCOUNTWORK" + work_id;
    obb["lvl" + (level + 1) + "_node_type"] = "ACCOUNTWORK";
    obb["lvl" + (level + 1) + "_value"] = this.obj["work_desc"];
    obb["lvl" + (level + 1) + "_type"] = "text";
 
    obb["leaf_user_cd"] = "ACCOUNTWORK" + work_id;
    obb["leaf_node_type"] = "ACCOUNTWORK";
    obb["leaf_value"] = this.obj["work_desc"];
    obb["module_cd"] = "ACCOUNT";

    // var resp = await this.hierarchyService.createHierarchy(obb);
    var resp = await this.hierarchyService.addModuleWorkInHierarchy(obb);
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'CREATE', message: "WORK IN PROJECT HIERARCHY CREATED SUCCESSFULLY" })
      return isError = false;
    } else {
      swal.fire('ERROR', resp.data, 'error')
      this.changeWorkStatus(work_id, 'INACTIVE')
      this.spinner.hide();
      return isError = true;
    }
  }

  apprflag: boolean = false;

  async getAllAccountWork(activeTab: string) {
    this.spinner.show();
    let assigned_work_ids: any = [];
    assigned_work_ids = await this.dataControlService.getWork();
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    let resp = await this.workS.getWorkList(obj);
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "ALL WORK LIST RECEIVED SUCCESSFULLY" })
      let allWork = resp.data;
      let assingedWork: any = [];
      // this.activeTab = activeTab
      allWork.map((x: any) => {
        if (assigned_work_ids.includes(x['work_id'])) {
          assingedWork.push(x)
        }
      })
      await this.ApprovalUserService.getWorkflowlog(this.erpUser, 'FILE', 'ACCOUNT')
      await this.activeClickedTab(activeTab)
      this.apprflag = this.ApprovalUserService.apprflag
      this.datasource = new MatTableDataSource(assingedWork)
      this.datasource.sort = this.sort.toArray()[0]
      this.datasource.paginator = this.paginator.toArray()[0]

      this.datasourceWork = new MatTableDataSource(allWork)
      this.datasourceWork.sort = this.sort.toArray()[1]
      this.datasourceWork.paginator = this.paginator.toArray()[1]
      this.spinner.hide();
      this.refresh();
    } else {
      this.spinner.hide();
      swal.fire("Error", "...Error while getting  all work list!", "error");
    }
  }


  // async getAllComputerWork(activeTab: string) {
  //   this.spinner.show();
  //   var obj: any = new Object();
  //   obj["b_acct_id"] = this.b_acct_id;
  //   obj["status"] = 'APPROVED';
  //   let resp = await this.computerFileService.getassignedwork(obj);
  //   if (resp["error"] == false) {
  //     this.log.createLog({ ...this.logObj, activity: 'GET', message: "COMPUTER WORK LIST RECEIVED SUCCESSFULLY" })
  //     // this.activeTab = activeTab
  //     resp.data.map((x: any) => {
  //       x['le_id'] = this.AllPartyObj[x['le_id']]
  //     })

  //     this.displayedColumns = this.module_displayedColumns;
  //     this.datasource = new MatTableDataSource(resp.data)
  //     this.datasource.sort = this.sort.toArray()[0]
  //     this.datasource.paginator = this.paginator.toArray()[0]
  //     await this.activeClickedTab(activeTab)
  //     this.spinner.hide();
  //   } else {
  //     this.spinner.hide();
  //     swal.fire("Error", "...Error while getting Computer File list!", "error");
  //   }
  // }


  // async getAllStoreWork(activeTab: string) {

  //   this.spinner.show();
  //   var obj: any = new Object();
  //   obj["b_acct_id"] = this.b_acct_id;
  //   obj["status"] = 'APPROVED';
  //   let resp = await this.stmFileService.getassignedwork(obj);
  //   if (resp["error"] == false) {
  //     // this.activeTab = activeTab
  //     this.log.createLog({ ...this.logObj, activity: 'GET', message: "STORE WORK LIST RECEIVED SUCCESSFULLY" })
  //     resp.data.map((x: any) => {
  //       x['le_id'] = this.AllPartyObj[x['le_id']]
  //     })
  //     this.datasource = new MatTableDataSource(resp.data)
  //     this.displayedColumns = this.module_displayedColumns;
  //     this.datasource.sort = this.sort.toArray()[0]
  //     this.datasource.paginator = this.paginator.toArray()[0]
  //     this.spinner.hide();
  //     // this.goToSTMAllModule()
  //     await this.activeClickedTab(activeTab)
  //   } else {
  //     this.spinner.hide();
  //     swal.fire("Error", "...Error while getting  all sal list!", "error");
  //   }
  // }

  async activeClickedTab(activeTab: any) {
    this.create_flag = false;
    this.view_details = false
    this.allWork_flage = false;
    this.update_flag = false;
    this.all_list_flag = true
    this.activeTab = activeTab;

  }


  async getAllModuleWork(activeTab: string) {
    this.spinner.show();

    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["work_status"] = 'APPROVED';
    let resp = await this.workS.getAllModuleWork(obj);
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All MODULE WORK LIST RECEIVED SUCCESSFULLY" })
      resp.data.map((x: any) => {
        x['le_id'] = this.AllPartyObj[x['le_id']]
      })
      await this.ApprovalUserService.getWorkflowlog(this.erpUser, 'FILE', 'ACCOUNT')
      this.apprflag = this.ApprovalUserService.apprflag

      this.displayedColumns = this.all_module_displayedColumns
      this.datasource = new MatTableDataSource(resp.data)

      this.activeTab = activeTab
      this.all_list_flag = true;
      this.datasource.sort = this.sort.toArray()[0]
      this.datasource.paginator = this.paginator.toArray()[0]
      await this.activeClickedTab(activeTab)
      this.spinner.hide ();


    } else {
      this.spinner.hide();
      swal.fire("Error", "...Error while getting  all sal list!", "error");
    }
  }



  applyFilter(filterValue: any) {
    this.datasource.filter = filterValue.target.value.trim().toLowerCase();
  }

  applyFilter1(filterValue1: any) {
    this.datasourceWork.filter = filterValue1.target.value.trim().toLowerCase();
  }

  checkDate() {
    if (this.obj["work_start_dt"] >= this.obj["work_end_dt"]) {
      swal.fire("ERROR", "End date can't be before or the same as the start date.", 'info');
      // this.obj["work_start_dt"] = '';
      this.obj["work_end_dt"] = null;
      return;
    }
    // if (this.obj["work_order_amt"] < 0) {
    //   this.spinner.hide();
    //   // swal.fire("ERROR", "Please Amount Should Be Greater Than Zero", 'info');
    //   // this.obj["work_order_amt"]=0;
    //   return;
    // }
  }
  // workorder_pdf1_file: any
  // workorder_pdf2_file: any
  // additional_doc_file: any
  fileNames = {
    workorder_pdf1: null,
    workorder_pdf2: null,
    additional_doc: null
  };


  workorderObj: any = {}
  fileName = ""

  onChange(event: any, type: any) {
    const clearInput = () => event.target.value = "";
    const file = event.target.files[0];

    if (event.target.files[0].type == "application/pdf") {
      this.fileName = file.name;
      if (this.obj['work_order_doc'] == this.fileName || this.obj['work_order_approval_doc'] == this.fileName || this.obj['additional_doc'] == this.fileName) {
        // swal.fire('Info', 'You can not upload the same document', 'info');
        swal.fire('Info', 'This document has already been uploaded. Please select other document.', 'info');
        clearInput();
        return;
      }
      else {

        if (type == 'WorkOrder_PDF1') {


          this.workorderObj['workorder_pdf1_file'] = file
          this.obj['work_order_doc'] = file.name

        } else if (type == 'WorkOrder_PDF2') {

          this.workorderObj['workorder_pdf2_file'] = file
          this.obj['work_order_approval_doc'] = file.name

        }
        // else {
        //   this.additional_document[i]['additional_doc_file'] = file
        //   this.additional_document[i]['additional_doc'] = file.name

        // }
      }

    }
    else {
      swal.fire("ERROR", "Only PDF files are allowed ", 'error');
      clearInput()
    }

  }



  onChangeAdditionalDoc(event: any, type: any, i: number) {

    const file = event.target.files[0];

    const clearInput = () => event.target.value = "";

    if (event.target.files[0].type == "application/pdf") {
      const file_name = file.name;
      const isFileNamePresent = this.additional_document.some((x: any) => x['file_name'] === file_name);
      if (this.obj['work_order_doc'] == file_name || this.obj['work_order_approval_doc'] == file_name || isFileNamePresent) {
        // swal.fire('Info', 'You can not upload the same document', 'info');
        swal.fire('Info', 'This document has already been uploaded. Please select other document.', 'info');
        clearInput()
        return;
      }
      else {
        this.additional_document[i]['file'] = file
        this.additional_document[i]['file_name'] = file.name
      }

    }
    else {
      swal.fire("ERROR", "Only PDF files are allowed ", 'error');
      clearInput();
    }
  }


  async validate() {
    let isError = false
    // if (!this.obj['proj_obj']['lvl2_cd']) {
    //   swal.fire('INFO', 'Please select project hierarchy atleast two level', 'info')
    //   return isError = true;
    // }
   
    if(!this.budDesc[this.obj['bud_cd']] ){
      swal.fire('INFO', 'Please select budget hierarchy ', 'info')
      return isError = true;
    }
    if (
      
      ( this.update_flag && this.obj['proj_obj'] ||
       !this.update_flag && !this.obj['proj_obj']['lvl2_cd'])  || !this.projectObj[this.obj['proj_cd']]
     ) {
      swal.fire('INFO', 'Please select project hierarchy atleast two level', 'info')
      return isError = true;
    }
    if(!this.productObj[this.obj['prod_cd']]){
      swal.fire('INFO', 'Please select product hierarchy ', 'info')
      return isError = true;
    }
    if( !this.activityObj[this.obj['act_cd']]){
      swal.fire('INFO', 'Please select activity hierarchy ', 'info')
      return isError = true;
    }
    if(!this.obj['work_order_amt']){
      swal.fire('INFO', 'Please enter file amount ', 'info')
      return isError = true;
    }
    // if (!this.budDesc[this.obj['bud_cd']] || !this.projectObj[this.obj['proj_cd']] ||
    //   !this.productObj[this.obj['prod_cd']] || !this.activityObj[this.obj['act_cd']] || !this.obj['work_order_amt']) return isError = true;

    if (this.obj['work_start_dt'] >= this.obj['work_end_dt']) {
      swal.fire('info', 'Start date and End date should not be equal or less then start date', 'info');
      return isError = true;
    }
    if (this.additional_document.length > 1) {
      const isExtraLinePresent = this.additional_document.some((x: any) => typeof (x) === 'string' ? x === null : x['file_name'] == null);
      if (isExtraLinePresent) {
        swal.fire('info', 'Please upload all additional document.', 'info');
        return isError = true;
      }
    }
    if (!this.obj['work_order_doc']) {
      swal.fire('info', 'Please Upload Notesheet Document', 'info');
      return isError = true;
    }

    if (!this.obj['work_order_approval_doc']) {
      swal.fire('info', 'Please Upload Reference Document', 'info');
      return isError = true;
    }
  

    // if (this.obj['work_order_amt'] > this.budAmtObj[this.obj['bud_cd']]) {
    //   this.max_amt_fg = true;
    //   swal.fire('WARNING', `Work Order Amount is greater Than Proposed Amount ( ${this.budAmtObj[this.obj['bud_cd']]} ) Of Selected Budget Hierarchy`, 'warning')
    //   return;
    // }
    return isError;
  }

  async submit() {
    if (await this.validate()) return;

    this.spinner.show();
    this.obj["create_user_id"] = this.user_id;
    this.obj["b_acct_id"] = this.erpUser.b_acct_id;
    this.obj["runnig_bill_no"] = 0;
    this.obj['additional_doc'] = this.additional_document.map((doc: any) => doc.file_name);
    let formdata = new FormData();
    formdata.append('file', this.workorderObj['workorder_pdf1_file']);
    formdata.append('file', this.workorderObj['workorder_pdf2_file']);
    // if (this.workorderObj['additional_doc_file']) {
    //   formdata.append('file', this.workorderObj['additional_doc_file']);
    // }
    if (this.obj['additional_doc'].length > 0) {
      // formdata.append('file', this.workorderObj['additional_doc_file']);
      this.additional_document.map((x: any) => {
        formdata.append('file', x['file'])
      })

    }
    formdata.append('details', JSON.stringify(this.obj));
    var resp = await this.workS.createWork(formdata);

    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'CREATE', message: "WORK CREATED SUCCESSFULLY" })
      this.spinner.hide();
      if (await this.addWorkInProjectHier(resp.data)) return;
      // await this.getAllAccountWork('account');
      swal.fire("Success...", 'File Added Successfully', "success");
      await this.getAllModuleWork('all');
      await this.listfunc();
      this.subreset.nativeElement.click();
      this.hiereset.nativeElement.click();
      this.max_amt_fg = false

    } else {
      this.spinner.hide();
      swal.fire("Error", resp.data, "error");
    }
  }
  async update() {
    if (await this.validate()) return;
    this.spinner.show();
    this.obj["update_user_id"] = this.user_id;
    this.obj["b_acct_id"] = this.b_acct_id;
    this.obj['additional_doc'] = this.additional_document.map((doc: any) => (typeof (doc) === 'string') ? doc : doc.file_name);
    let formdata = new FormData();
    if (this.previous_pdf.pdf1 != this.obj['work_order_doc']) {
      formdata.append('file', this.workorderObj['workorder_pdf1_file']);
    }
    if (this.previous_pdf.pdf2 != this.obj['work_order_approval_doc']) {
      formdata.append('file', this.workorderObj['workorder_pdf2_file']);
    }
    // if (this.previous_pdf.pdf3 != this.obj['additional_doc']) {
    //   formdata.append('file', this.workorderObj['additional_doc_file']);
    // }
    if (this.obj['additional_doc'].length > 0) {
      // formdata.append('file', this.workorderObj['additional_doc_file']);
      this.additional_document.map((x: any) => {
        formdata.append('file', x['file'])
      })

    }
    formdata.append('details', JSON.stringify(this.obj));
    var resp = await this.workS.updateWork(formdata);
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'UPDATE', message: "WORK " + this.obj["work_id"] + " UPDATED SUCCESSFULLY" })
      swal.fire("Success...", "Work Updated Successfully", "success");
      
      await this.getAllModuleWork('all');
      // await this.getAllAccountWork('account')
      await this.listfunc();
      this.resetUpdate.nativeElement.click()
      this.previous_pdf = {}
      this.workorderObj = {}
      this.spinner.hide();
    } else {
      this.spinner.hide();
      swal.fire("Error", "...Error While Updating", "error");
      this.previous_pdf = {}
    }
  }



  async changeWorkStatus(id: number, status: any) {
    this.spinner.show();
    let obj: any = {}
    obj["update_user_id"] = this.user_id;
    obj["b_acct_id"] = this.b_acct_id;
    obj['status'] = status
    obj['work_id'] = id
    var resp = await this.workS.changeWorkStatus(obj);
    if (resp["error"] == false) {
    } else {
      this.spinner.hide();
      swal.fire("Error", "...Error While Updating Work Status", "error");
    }
  }


  refresh() {
    this.obj = { prod_cd: "", act_cd: "", proj_cd: "", bud_cd: "" };
  }
  async delete(data: any) {

    swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.value) {
        this.spinner.show();
        this.obj["work_id"] = data["work_id"];
        this.obj["b_acct_id"] = this.b_acct_id;
        var resp = await this.workS.deleteWork(this.obj);
        if (resp["error"] == false) {
          this.log.createLog({ ...this.logObj, activity: 'DELETE', message: "WORK " + this.obj["work_id"] + " DELETE SUCCESSFULLY" })
          this.spinner.hide();
          // this.getAllAccountWork('account');
          await this.getAllModuleWork('all');
          swal.fire("Success...", "File Deleted Successfully", "success");
        } else {
          this.spinner.hide();
          swal.fire("Success...", resp.data, "error");
        }
      }
    })
  }
  async listfunc() {
    this.create_flag = false;
    this.view_details = false
    this.allWork_flage = false;
    this.update_flag = false;
    this.all_list_flag = true
    // if (this.activeTab == 'account') {
      await this.getAllAccountWork('account');
    // } else if (this.activeTab == 'computer') {
    //   await this.getAllComputerWork('computer');
    // } else if (this.activeTab == 'store') {
    //   await this.getAllStoreWork('store');
    // } else if (this.activeTab == 'all') {
    //   await this.getAllModuleWork('all');
    // }
  }
  previous_pdf: any = {
    pdf1: null,
    pdf2: null,
    pdf3: null,
  }
  open_update(element: any) {
    this.refresh()
    this.previous_pdf = {
      pdf1: element.work_order_doc,
      pdf2: element.work_order_approval_doc,
      // pdf3: element.additional_doc,
    }
    if (element?.additional_doc) {
      this.additional_document = JSON.parse(element?.additional_doc);
    } else {
      this.additional_document = [{ file_name: null, file: null, show_file_name_on_update: true }]
    }
    this.create_flag = false;
    this.all_list_flag = false;
    this.allWork_flage = false;
    this.update_flag = true;
    this.all_list_flag = false;


    this.obj = Object.assign({}, element);
    this.setPartyDetails();

    $('.nav-tabs a[href="#tab-3"]').tab("show");
  }

  //******************************************************************************************************************* */
  budDesc: any = {};
  budAmtObj: any = {}
  hierobj: any = { budget: {}, activity: {}, product: {}, project: {} };

  async getAllBudget() {
    this.spinner.show();
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["table_name"] = "bud_hier";
    var resp = await this.hierarchyService.getBudgetHierarchy(obj);
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "BUDGET HIERARCHY LIST RECEIVED SUCCESSFULLY" })
      this.spinner.hide();
      this.allBudgetHier = resp.data.filter((x: any) => { return x['fin_year'] == this.fin_year });

      for (let i = 0; i < this.allBudgetHier.length; i++) {
        this.budAmtObj[this.allBudgetHier[i]["leaf_cd"]] = this.allBudgetHier[i]["remaining_amount"]
        let str = "";
        for (let j = 1; j < 8; j++) {
          if (this.allBudgetHier[i]["lvl" + j + "_cd"] != null && this.allBudgetHier[i]["lvl" + j + "_cd"] != "") {
            str += this.allBudgetHier[i]["lvl" + j + "_value"] + " > ";
          }
        }

        str = str.substring(0, str.length - 2);
        this.allBudgetHier[i]["desc"] = str;
        this.budDesc[this.allBudgetHier[i]["leaf_cd"]] = str;
        this.hierobj["budget"][this.allBudgetHier[i]["leaf_cd"]] =
          this.allBudgetHier[i];
      }

    } else {
      this.spinner.hide();
    }
  }

  projectObj: any = {};
  async getAllProject() {
    this.spinner.show()
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["table_name"] = "proj_hier";
    var resp = await this.hierarchyService.getProjectHierarchy(obj);
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "PROJECT HIERARCHY LIST RECEIVED SUCCESSFULLY" })
      this.allProjectHier = resp.data;
      let proj: any = [];
      await this.allProjectHier.map((x: any) => {
        if (
          x["leaf_node_type"] == "HREMP" ||
          x["leaf_node_type"] == "ACCOUNTWORK" ||
          x["leaf_node_type"] == "EMBWORK" ||
          x["leaf_node_type"] == "PROPERTY"
        ) {
        } else {
          proj.push(x);
        }
      });
      this.allProjectHier = [];
      this.allProjectHier = proj;

      for (let i = 0; i < this.allProjectHier.length; i++) {
        let str = "";
        for (let j = 1; j < 8; j++) {
          if (
            this.allProjectHier[i]["lvl" + j + "_cd"] != null &&
            this.allProjectHier[i]["lvl" + j + "_cd"] != ""
          ) {
            str += this.allProjectHier[i]["lvl" + j + "_value"] + " > ";
          }
        }

        str = str.substring(0, str.length - 2);
        this.allProjectHier[i]["desc"] = str;
        this.projectObj[this.allProjectHier[i]["leaf_cd"]] = str;
        this.hierobj["project"][this.allProjectHier[i]["leaf_cd"]] =
          this.allProjectHier[i];
          this.spinner.hide()
      }
    } else {
      this.spinner.hide()
    }
  }

  productObj: any = {};
  async getAllProduct() {
    this.spinner.show()
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["table_name"] = "prod_hier";
    var resp = await this.hierarchyService.getProductHierarchy(obj);
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "PRODUCT HIERARCHY LIST RECEIVED SUCCESSFULLY" })
      this.allProductHier = resp.data;
      for (let i = 0; i < this.allProductHier.length; i++) {
        let str = "";
        for (let j = 1; j < 8; j++) {
          if (
            this.allProductHier[i]["lvl" + j + "_cd"] != null &&
            this.allProductHier[i]["lvl" + j + "_cd"] != ""
          ) {
            str += this.allProductHier[i]["lvl" + j + "_value"] + " > ";
          }
        }

        str = str.substring(0, str.length - 2);
        this.allProductHier[i]["desc"] = str;
        this.productObj[this.allProductHier[i]["leaf_cd"]] = str;
        this.hierobj["product"][this.allProductHier[i]["leaf_cd"]] =
          this.allProductHier[i];
      }
      this.spinner.hide()
    } else {
      this.spinner.hide()
    }
  }

  fin_year: any
  async getActiveFinYear() {
    this.spinner.show()
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.ledgerService.getActiveFinYear(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "ACTIVE FIN YEAR RECEIVED SUCCESSFULLY" })
      if (resp.data.length == 0) {
        // swal.fire("Warning", "..Active Financial Year Not set!", 'warning');
      } else {
        this.fin_year = resp.data[0].fin_year;
        
      }
      this.spinner.hide()
    } else {
      this.spinner.hide()
      // swal.fire("Error", "..Error while getting active  fin year!", 'error');
    }
  }


  activityObj: any = {};
  async getAllActivity() {
    this.spinner.show() 
    var obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["table_name"] = "activity_hier";
    var resp = await this.hierarchyService.getActivityHierarchy(obj);
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "ACTIVITY HIERARCHY LIST RECEIVED SUCCESSFULLY" })
      this.allActivityHier = resp.data;
      for (let i = 0; i < this.allActivityHier.length; i++) {
        let str = "";
        for (let j = 1; j < 8; j++) {
          if (
            this.allActivityHier[i]["lvl" + j + "_cd"] != null &&
            this.allActivityHier[i]["lvl" + j + "_cd"] != ""
          ) {
            str += this.allActivityHier[i]["lvl" + j + "_value"] + " > ";
          }
        }

        str = str.substring(0, str.length - 2);
        this.allActivityHier[i]["desc"] = str;
        this.activityObj[this.allActivityHier[i]["leaf_cd"]] = str;
        this.hierobj["activity"][this.allActivityHier[i]["leaf_cd"]] =
          this.allActivityHier[i];
          this.spinner.hide()
      }
    } else {
      this.spinner.hide()
    }
  }

  level1: any = [];
  level2: any = [];
  level3: any = [];
  level4: any = [];
  level5: any = [];
  level6: any = [];
  level7: any = [];
  Hier: any = [];
  hier_type: any;
  HierSelectObj: any = {};
  selectObj: any = {};
  HierSelectobj: any;

  async Select(type: any) {
    $("#select").modal("show");
    this.hier_type = type;
    let ob = {};

    if (type == "budget") {
      this.Hier = this.allBudgetHier;
      if (this.selectObj["bud_cd"] != null && this.selectObj["bud_cd"] != "") {
        ob = this.hierobj["budget"][this.selectObj["bud_cd"]];
      }
    } else if (type == "activity") {
      this.Hier = this.allActivityHier;
      if (this.selectObj["act_cd"] != null && this.selectObj["act_cd"] != "") {
        ob = this.hierobj["activity"][this.selectObj["act_cd"]];
      }
    } else if (type == "project") {
      this.Hier = this.allProjectHier;
      if (
        this.selectObj["proj_cd"] != null &&
        this.selectObj["proj_cd"] != ""
      ) {
        ob = this.hierobj["project"][this.selectObj["proj_cd"]];
      }
    } else if (type == "product") {
      this.Hier = this.allProductHier;
      if (
        this.selectObj["prod_cd"] != null &&
        this.selectObj["prod_cd"] != ""
      ) {
        ob = this.hierobj["product"][this.selectObj["prod_cd"]];
      }
    }
    this.HierSelectObj = {};
    await this.getLevel1();
    if (Object.keys(ob).length != 0) {
      this.HierSelectObj = Object.assign({}, ob);
      await this.onChangeLvl1();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl2();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl3();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl4();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl5();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl6();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl7();
    }
  }

  async selectCreate(type: any) {
    // this.hiereset.nativeElement.click()
    $("#selectCreate").modal("show");
    this.hier_type = type;
    let ob = {};
    if (type == "budget") {
      this.Hier = this.allBudgetHier;
      if (this.obj["bud_cd"] != null && this.obj["bud_cd"] != "") {
        ob = this.hierobj["budget"][this.obj["bud_cd"]];
      }
    } else if (type == "activity") {
      this.Hier = this.allActivityHier;
      if (this.obj["act_cd"] != null && this.obj["act_cd"] != "") {
        ob = this.hierobj["activity"][this.obj["act_cd"]];
      }
    } else if (type == "project") {
      this.Hier = this.allProjectHier;
      if (this.obj["proj_cd"] != null && this.obj["proj_cd"] != "") {
        ob = this.hierobj["project"][this.obj["proj_cd"]];
      }
    } else if (type == "product") {
      this.Hier = this.allProductHier;
      if (this.obj["prod_cd"] != null && this.obj["prod_cd"] != "") {
        ob = this.hierobj["product"][this.obj["prod_cd"]];
      }
    }
    this.HierSelectObj = {};
    await this.getLevel1();
    if (Object.keys(ob).length != 0) {
      this.HierSelectObj = Object.assign({}, ob);
      await this.onChangeLvl1();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl2();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl3();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl4();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl5();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl6();
      this.HierSelectObj = Object.assign({}, ob);

      await this.onChangeLvl7();
    }
  }
  async getLevel1() {
    this.level1 = [];
    for (let i = 0; i < this.Hier.length; i++) {
      if (this.Hier[i]["lvl1_cd"] == this.Hier[i]["leaf_cd"]) {
        let ob: any = new Object();
        ob["lvl1_cd"] = this.Hier[i]["lvl1_cd"];
        ob["lvl1_value"] = this.Hier[i]["lvl1_value"];
        ob["is_leaf"] = this.Hier[i]["is_leaf"];

        this.level1.push(ob);
      }
    }

    this.level2 = [];
    this.level3 = [];
    this.level4 = [];
    this.level5 = [];
    this.level6 = [];
    this.level7 = [];
  }

  async onChangeLvl1() {
    if (
      this.HierSelectObj["lvl1_cd"] == "" ||
      this.HierSelectObj["lvl1_cd"] == null
    ) {
      this.HierSelectObj["leaf_cd"] = "";
      this.HierSelectObj["leaf_value"] = "";
    }
    for (let i = 0; i < this.level1.length; i++) {
      if (this.level1[i]["lvl1_cd"] == this.HierSelectObj["lvl1_cd"]) {
        this.HierSelectObj["lvl1_value"] = this.level1[i]["lvl1_value"];
        await this.makingLeafValues();
      }
    }
    let temp = [];
    this.level2 = [];
    for (let i = 0; i < this.Hier.length; i++) {
      if (this.Hier[i]["lvl1_cd"] == this.HierSelectObj["lvl1_cd"] && this.Hier[i]["lvl2_cd"] != null) {
        if (this.Hier[i]["lvl2_cd"] == this.Hier[i]["leaf_cd"]) {
          let ob: any = new Object();
          ob["lvl2_cd"] = this.Hier[i]["lvl2_cd"];
          ob["lvl2_value"] = this.Hier[i]["lvl2_value"];
          ob["is_leaf"] = this.Hier[i]["is_leaf"];

          this.level2.push(ob);
        }
      }
    }
    this.level3 = [];
    this.level4 = [];
    this.level5 = [];
    this.level6 = [];
    this.level7 = [];

    for (let i = 2; i < 8; i++) {
      this.HierSelectObj["lvl" + i + "_cd"] = null;
      this.HierSelectObj["lvl" + i + "_value"] = null;
    }
  }
  async onChangeLvl2() {
    if (
      this.HierSelectObj["lvl2_cd"] == "" ||
      this.HierSelectObj["lvl2_cd"] == null
    ) {
      this.HierSelectObj["leaf_cd"] = "";
      this.HierSelectObj["leaf_value"] = "";
    }
    for (let i = 0; i < this.level2.length; i++) {
      if (this.level2[i]["lvl2_cd"] == this.HierSelectObj["lvl2_cd"]) {
        this.HierSelectObj["lvl2_value"] = this.level2[i]["lvl2_value"];
        await this.makingLeafValues();
      }
    }
    let temp = [];
    this.level3 = [];
    for (let i = 0; i < this.Hier.length; i++) {
      if (
        this.Hier[i]["lvl2_cd"] == this.HierSelectObj["lvl2_cd"] &&
        this.Hier[i]["lvl3_cd"] != null
      ) {
        if (this.Hier[i]["lvl3_cd"] == this.Hier[i]["leaf_cd"]) {
          let ob: any = new Object();
          ob["lvl3_cd"] = this.Hier[i]["lvl3_cd"];
          ob["lvl3_value"] = this.Hier[i]["lvl3_value"];
          ob["is_leaf"] = this.Hier[i]["is_leaf"];

          this.level3.push(ob);
        }
      }
    }

    this.level4 = [];
    this.level5 = [];
    this.level6 = [];
    this.level7 = [];

    for (let i = 3; i < 8; i++) {
      this.HierSelectObj["lvl" + i + "_cd"] = null;
      this.HierSelectObj["lvl" + i + "_value"] = null;
    }
  }

  async onChangeLvl3() {
    if (
      this.HierSelectObj["lvl3_cd"] == "" ||
      this.HierSelectObj["lvl3_cd"] == null
    ) {
      this.HierSelectObj["leaf_cd"] = "";
      this.HierSelectObj["leaf_value"] = "";
    }
    for (let i = 0; i < this.level3.length; i++) {
      if (this.level3[i]["lvl3_cd"] == this.HierSelectObj["lvl3_cd"]) {
        this.HierSelectObj["lvl3_value"] = this.level3[i]["lvl3_value"];
        await this.makingLeafValues();
      }
    }
    let temp = [];
    this.level4 = [];
    for (let i = 0; i < this.Hier.length; i++) {
      if (
        this.Hier[i]["lvl3_cd"] == this.HierSelectObj["lvl3_cd"] &&
        this.Hier[i]["lvl4_cd"] != null
      ) {
        if (this.Hier[i]["lvl4_cd"] == this.Hier[i]["leaf_cd"]) {
          let ob: any = new Object();
          ob["lvl4_cd"] = this.Hier[i]["lvl4_cd"];
          ob["lvl4_value"] = this.Hier[i]["lvl4_value"];
          ob["is_leaf"] = this.Hier[i]["is_leaf"];

          this.level4.push(ob);
        }
      }
    }

    this.level5 = [];
    this.level6 = [];
    this.level7 = [];

    for (let i = 4; i < 8; i++) {
      this.HierSelectObj["lvl" + i + "_cd"] = null;
      this.HierSelectObj["lvl" + i + "_value"] = null;
    }
  }

  async onChangeLvl4() {
    if (
      this.HierSelectObj["lvl4_cd"] == "" ||
      this.HierSelectObj["lvl4_cd"] == null
    ) {
      this.HierSelectObj["leaf_cd"] = "";
      this.HierSelectObj["leaf_value"] = "";
    }
    for (let i = 0; i < this.level4.length; i++) {
      if (this.level4[i]["lvl4_cd"] == this.HierSelectObj["lvl4_cd"]) {
        this.HierSelectObj["lvl4_value"] = this.level4[i]["lvl4_value"];
        await this.makingLeafValues();
      }
    }
    let temp = [];
    this.level5 = [];
    for (let i = 0; i < this.Hier.length; i++) {
      if (
        this.Hier[i]["lvl4_cd"] == this.HierSelectObj["lvl4_cd"] &&
        this.Hier[i]["lvl5_cd"] != null
      ) {
        if (this.Hier[i]["lvl5_cd"] == this.Hier[i]["leaf_cd"]) {
          let ob: any = new Object();
          ob["lvl5_cd"] = this.Hier[i]["lvl5_cd"];
          ob["lvl5_value"] = this.Hier[i]["lvl5_value"];
          ob["is_leaf"] = this.Hier[i]["is_leaf"];

          this.level5.push(ob);
        }
      }
    }
    this.level6 = [];
    this.level7 = [];

    for (let i = 5; i < 8; i++) {
      this.HierSelectObj["lvl" + i + "_cd"] = null;
      this.HierSelectObj["lvl" + i + "_value"] = null;
    }
  }

  async onChangeLvl5() {
    if (
      this.HierSelectObj["lvl5_cd"] == "" ||
      this.HierSelectObj["lvl5_cd"] == null
    ) {
      this.HierSelectObj["leaf_cd"] = "";
      this.HierSelectObj["leaf_value"] = "";
    }
    for (let i = 0; i < this.level5.length; i++) {
      if (this.level5[i]["lvl5_cd"] == this.HierSelectObj["lvl5_cd"]) {
        this.HierSelectObj["lvl5_value"] = this.level5[i]["lvl5_value"];
        await this.makingLeafValues();
      }
    }
    let temp = [];
    this.level6 = [];
    for (let i = 0; i < this.Hier.length; i++) {
      if (
        this.Hier[i]["lvl5_cd"] == this.HierSelectObj["lvl5_cd"] &&
        this.Hier[i]["lvl6_cd"] != null
      ) {
        if (this.Hier[i]["lvl6_cd"] == this.Hier[i]["leaf_cd"]) {
          let ob: any = new Object();
          ob["lvl6_cd"] = this.Hier[i]["lvl6_cd"];
          ob["lvl6_value"] = this.Hier[i]["lvl6_value"];
          ob["is_leaf"] = this.Hier[i]["is_leaf"];

          this.level6.push(ob);
        }
      }
    }
    this.level7 = [];

    for (let i = 6; i < 8; i++) {
      this.HierSelectObj["lvl" + i + "_cd"] = null;
      this.HierSelectObj["lvl" + i + "_value"] = null;
    }
  }

  async onChangeLvl6() {
    if (
      this.HierSelectObj["lvl7_cd"] == "" ||
      this.HierSelectObj["lvl7_cd"] == null
    ) {
      this.HierSelectObj["leaf_cd"] = "";
      this.HierSelectObj["leaf_value"] = "";
    }
    for (let i = 0; i < this.level6.length; i++) {
      if (this.level6[i]["lvl6_cd"] == this.HierSelectObj["lvl6_cd"]) {
        this.HierSelectObj["lvl6_value"] = this.level6[i]["lvl6_value"];
        await this.makingLeafValues();
      }
    }
    let temp = [];
    this.level7 = [];
    for (let i = 0; i < this.Hier.length; i++) {
      if (
        this.Hier[i]["lvl6_cd"] == this.HierSelectObj["lvl6_cd"] &&
        this.Hier[i]["lvl7_cd"] != null
      ) {
        if (this.Hier[i]["lvl7_cd"] == this.Hier[i]["leaf_cd"]) {
          let ob: any = new Object();
          ob["lvl7_cd"] = this.Hier[i]["lvl7_cd"];
          ob["lvl7_value"] = this.Hier[i]["lvl7_value"];
          ob["is_leaf"] = this.Hier[i]["is_leaf"];

          this.level7.push(ob);
        }
      }
    }

    for (let i = 7; i < 8; i++) {
      this.HierSelectObj["lvl" + i + "_cd"] = null;
      this.HierSelectObj["lvl" + i + "_value"] = null;
    }
  }

  async onChangeLvl7() {
    for (let i = 0; i < this.level7.length; i++) {
      if (this.level7[i]["lvl7_cd"] == this.HierSelectObj["lvl7_cd"]) {
        this.HierSelectObj["lvl7_value"] = this.level7[i]["lvl7_value"];
      }
    }

    await this.makingLeafValues();
  }

  async makingLeafValues() {
    this.leaf_msg = false;
    if (
      this.HierSelectObj["lvl7_cd"] != undefined &&
      this.HierSelectObj["lvl7_cd"] != "" &&
      this.HierSelectObj["lvl7_cd"] != null
    ) {
      this.HierSelectObj["leaf_cd"] = this.HierSelectObj["lvl7_cd"];
      this.HierSelectObj["leaf_value"] = this.HierSelectObj["lvl7_value"];
    } else if (
      this.HierSelectObj["lvl6_cd"] != undefined &&
      this.HierSelectObj["lvl6_cd"] != "" &&
      this.HierSelectObj["lvl6_cd"] != null
    ) {
      this.HierSelectObj["leaf_cd"] = this.HierSelectObj["lvl6_cd"];
      this.HierSelectObj["leaf_value"] = this.HierSelectObj["lvl6_value"];
    } else if (
      this.HierSelectObj["lvl5_cd"] != undefined &&
      this.HierSelectObj["lvl5_cd"] != "" &&
      this.HierSelectObj["lvl5_cd"] != null
    ) {
      this.HierSelectObj["leaf_cd"] = this.HierSelectObj["lvl5_cd"];
      this.HierSelectObj["leaf_value"] = this.HierSelectObj["lvl5_value"];
    } else if (
      this.HierSelectObj["lvl4_cd"] != undefined &&
      this.HierSelectObj["lvl4_cd"] != "" &&
      this.HierSelectObj["lvl4_cd"] != null
    ) {
      this.HierSelectObj["leaf_cd"] = this.HierSelectObj["lvl4_cd"];
      this.HierSelectObj["leaf_value"] = this.HierSelectObj["lvl4_value"];
    } else if (
      this.HierSelectObj["lvl3_cd"] != undefined &&
      this.HierSelectObj["lvl3_cd"] != "" &&
      this.HierSelectObj["lvl3_cd"] != null
    ) {
      this.HierSelectObj["leaf_cd"] = this.HierSelectObj["lvl3_cd"];
      this.HierSelectObj["leaf_value"] = this.HierSelectObj["lvl3_value"];
    } else if (
      this.HierSelectObj["lvl2_cd"] != undefined &&
      this.HierSelectObj["lvl2_cd"] != "" &&
      this.HierSelectObj["lvl2_cd"] != null
    ) {
      this.HierSelectObj["leaf_cd"] = this.HierSelectObj["lvl2_cd"];
      this.HierSelectObj["leaf_value"] = this.HierSelectObj["lvl2_value"];
    } else if (
      this.HierSelectObj["lvl1_cd"] != undefined &&
      this.HierSelectObj["lvl1_cd"] != "" &&
      this.HierSelectObj["lvl1_cd"] != null
    ) {
      this.HierSelectObj["leaf_cd"] = this.HierSelectObj["lvl1_cd"];
      this.HierSelectObj["leaf_value"] = this.HierSelectObj["lvl1_value"];
    }
  }
  async SubmitSelectedListHier() {
    let levelnum = 0;
    for (let i = 1; i < 8; i++) {
      if (
        this.HierSelectObj["lvl" + i + "_cd"] != null &&
        this.HierSelectObj["lvl" + i + "_cd"] != ""
      ) {
        levelnum = i;
      }
    }
    if (this.hier_type == "budget") {
      for (let i = 0; i < this.allBudgetHier.length; i++) {
        if (
          this.allBudgetHier[i]["leaf_cd"] ==
          this.HierSelectObj["lvl" + levelnum + "_cd"]
        ) {
          this.selectObj["bud_desc"] = this.allBudgetHier[i]["desc"];
          this.selectObj["bud_cd"] = this.allBudgetHier[i]["leaf_cd"];
          this.selectObj["bud_lvl"] = this.allBudgetHier[i]["level"];
          this.selectObj["bud_obj"] = this.allBudgetHier[i];
        }
      }
    } else if (this.hier_type == "activity") {
      for (let i = 0; i < this.allActivityHier.length; i++) {
        if (
          this.allActivityHier[i]["leaf_cd"] ==
          this.HierSelectObj["lvl" + levelnum + "_cd"]
        ) {
          this.selectObj["act_desc"] = this.allActivityHier[i]["desc"];
          this.selectObj["act_cd"] = this.allActivityHier[i]["leaf_cd"];
          this.selectObj["act_lvl"] = this.allActivityHier[i]["level"];
          this.selectObj["act_obj"] = this.allActivityHier[i];
        }
      }
    } else if (this.hier_type == "project") {
      for (let i = 0; i < this.allProjectHier.length; i++) {
        if (
          this.allProjectHier[i]["leaf_cd"] ==
          this.HierSelectObj["lvl" + levelnum + "_cd"]
        ) {
          this.selectObj["proj_desc"] = this.allProjectHier[i]["desc"];
          this.selectObj["proj_cd"] = this.allProjectHier[i]["leaf_cd"];
          this.selectObj["proj_lvl"] = this.allProjectHier[i]["level"];
          this.selectObj["proj_obj"] = this.allProjectHier[i];
        }
      }
    } else if (this.hier_type == "product") {
      for (let i = 0; i < this.allProductHier.length; i++) {
        if (
          this.allProductHier[i]["leaf_cd"] ==
          this.HierSelectObj["lvl" + levelnum + "_cd"]
        ) {
          this.selectObj["prod_cd"] = this.allProductHier[i]["leaf_cd"];
          this.selectObj["prod_desc"] = this.allProductHier[i]["desc"];
          this.selectObj["prod_lvl"] = this.allProductHier[i]["level"];
          this.selectObj["prod_obj"] = this.allProductHier[i];
        }
      }
    }

    $("#select").modal("hide");
  }
  leaf_msg = false;
  SubmitListHierforCreate() {
    if (
      this.HierSelectObj["leaf_cd"] == "" ||
      this.HierSelectObj["leaf_cd"] == null
    ) {
      this.leaf_msg = true;      // swal.fire("Error", "Please select till leaf.");
      return;
    }
    if (this.hier_type == "budget") {
      for (let i = 0; i < this.allBudgetHier.length; i++) {
        if (this.allBudgetHier[i]["leaf_cd"] == this.HierSelectObj["leaf_cd"]) {
          this.obj["bud_desc"] = this.allBudgetHier[i]["desc"];
          this.obj["bud_cd"] = this.allBudgetHier[i]["leaf_cd"];
          this.obj["bud_lvl"] = this.allBudgetHier[i]["level"];
          this.obj["bud_obj"] = this.allBudgetHier[i];
          $("#selectCreate").modal("hide");
          this.hiereset.nativeElement.click()
        }
      }
    } else if (this.hier_type == "activity") {
      for (let i = 0; i < this.allActivityHier.length; i++) {
        if (this.allActivityHier[i]["leaf_cd"] == this.HierSelectObj["leaf_cd"]) {
          this.obj["act_desc"] = this.allActivityHier[i]["desc"];
          this.obj["act_cd"] = this.allActivityHier[i]["leaf_cd"];
          this.obj["act_lvl"] = this.allActivityHier[i]["level"];
          this.obj["act_obj"] = this.allActivityHier[i];
          this.checkTillLeaf(this.allActivityHier)
        }
      }
    } else if (this.hier_type == "project") {
      for (let i = 0; i < this.allProjectHier.length; i++) {
        if (
          this.allProjectHier[i]["leaf_cd"] == this.HierSelectObj["leaf_cd"]
        ) {
          this.obj["proj_desc"] = this.allProjectHier[i]["desc"];
          this.obj["proj_cd"] = this.allProjectHier[i]["leaf_cd"];
          this.obj["proj_lvl"] = this.allProjectHier[i]["level"];
          this.obj["proj_obj"] = this.allProjectHier[i];
          if (!this.obj['proj_obj']['lvl2_cd']) {
            swal.fire('INFO', 'Please select atleast two level', 'info')
            return;
          }
          $("#selectCreate").modal("hide");
          this.hiereset.nativeElement.click()
        }
      }
    } else if (this.hier_type == "product") {
      for (let i = 0; i < this.allProductHier.length; i++) {
        if (
          this.allProductHier[i]["leaf_cd"] == this.HierSelectObj["leaf_cd"]
        ) {
          this.obj["prod_cd"] = this.allProductHier[i]["leaf_cd"];
          this.obj["prod_desc"] = this.allProductHier[i]["desc"];
          this.obj["prod_lvl"] = this.allProductHier[i]["level"];
          this.obj["prod_obj"] = this.allProductHier[i];
          $("#selectCreate").modal("hide");
          this.hiereset.nativeElement.click()
        }
      }
    }
   
    // $("#selectCreate").modal("hide");
  }

  checkTillLeaf(hierarchy: any) {
    // hierarchy.map((x:any)=>{
    //   if(x['le'])
    // })
    let isLeaf: boolean = true;
    this.leaf_msg = false;
    let level = 0;
    for (let i = 0; i < hierarchy.length; i++) {
      if (hierarchy[i]['leaf_cd'] == this.HierSelectObj["leaf_cd"]) {
        for (let j = 1; j < 8; j++) {
          if (hierarchy[i]['lvl' + j + '_cd']) {
            level++;
          }
        }
        for (let k = i; k < hierarchy.length; k++) {
          if ((hierarchy[k]['lvl' + level + '_cd'] === this.HierSelectObj["leaf_cd"]) && hierarchy[k]['lvl' + (level + 1) + '_cd']) {
            isLeaf = false;
            break;
          }
        }
      }
    }
    if (!isLeaf) {
      this.leaf_msg = true;
    } else {
      $("#selectCreate").modal("hide");
      this.hiereset.nativeElement.click()
    }
  }
  closeModel(){
    $("#selectCreate").modal("hide");
    this.hiereset.nativeElement.click() 
    this.leaf_msg = false;
  }
  async backToList() {
    this.view_details = false;
    this.create_flag = false;
    this.update_flag = false;
    this.allWork_flage = false;
    this.all_list_flag = true
    this.activeTab = this.activeTab.substring(0, this.activeTab.length - 1)
    // if (this.activeTab == 'account') {
      await this.getAllAccountWork('account');
    // } else if (this.activeTab == 'computer') {
    //   await this.getAllComputerWork('computer');
    // } else if (this.activeTab == 'store') {
    //   await this.getAllStoreWork('store');
    // } else if (this.activeTab == 'all') {
    //   await this.getAllModuleWork('all');
    // }
  }
  workDetailsObj: any;
  async viewDeatils(element: any, is_download: number) {

    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['local_doc_no'] = element.work_id
    this.activeTab += '1'
    // const resp = await this.processDocumentPrintService.getWorkDetailsByID(obj)
    let resp: any = null;
    // if (element.module_cd == 'ACCOUNT') {
      resp = await this.processDocumentPrintService.getWorkDetailsByID(obj)
    // } else if (element.module_cd == 'COMPUTER') {
    //   resp = await this.computerFileService.getComputerWorkDetailsByID(obj)
    // } else if (element.module_cd == 'STM') {
    //   resp = await this.stmFileService.getSTMWorkDetailsByID(obj)
    // }

    if (!resp['error']) {
      this.workDetailsObj = resp['data']
      if (!is_download) {
        this.view_details = true;
        this.all_list_flag = false;
        this.create_flag = false;
        this.update_flag = false;
        this.allWork_flage = false;
        this.all_list_flag = false;
      } else {
        this.print()
      }

    }

  }

  async viewDoc(element: any, doc_key: any) {
    let obj_doc = Object()
    obj_doc['b_acct_id'] = this.b_acct_id;
    obj_doc['work_id'] = element.work_id ? element.work_id : this.obj.work_id
    obj_doc['file_name'] = element[doc_key] ? element[doc_key] : this.obj[doc_key] ? this.obj[doc_key] : doc_key



   

    // if ( element.module_cd ? element.module_cd == 'ACCOUNT' : this.obj.module_cd == 'ACCOUNT') {
      await this.workS.viewDoc(obj_doc)
    // } else if ( element.module_cd ? element.module_cd  == 'COMPUTER': this.obj.module_cd == 'COMPUTER') {
    //   await this.computerFileService.viewDoc(obj_doc)
    // } else if ( element.module_cd ? element.module_cd == 'STM' : this.obj.module_cd == 'STM') {
    //   await this.stmFileService.viewDoc(obj_doc)
    // }


    // if (element.module_cd == 'ACCOUNT') {
    //   await this.workS.viewDoc(obj_doc)
    // } else if (element.module_cd == 'COMPUTER') {
    //   await this.computerFileService.viewDoc(obj_doc)
    // } else if (element.module_cd == 'STM') {
    //   await this.stmFileService.viewDoc(obj_doc)
    // }
  }


  isModalVisible: boolean = false;
  closeModal() {
    this.isModalVisible = !this.isModalVisible;
  }

  assignmentObj: any = {}
  openAssignment(element: any): void {
    this.assignmentObj = { work_id: element?.work_id, work_assign_id: element?.work_assign_id, module_cd: element.module_cd };
    $('#work_assign').modal('show');
  }


  async workAssignment() {
    if (!this.assignmentObj["le_id"]) {
      swal.fire('INFO', 'Please Select Party', 'info')
      return;
    }
    if (!this.assignmentObj["module_cd"]) {
      swal.fire('INFO', 'Please Change Tab', 'info')
      return;
    }
    this.spinner.show();
    this.assignmentObj["create_user_id"] = this.user_id;
    this.assignmentObj["b_acct_id"] = this.erpUser.b_acct_id;
    this.assignmentObj["status"] = 'ACTIVE'
    const resp = await this.workS.workAssignment(this.assignmentObj);
    if (resp["error"] == false) {
      this.log.createLog({ ...this.logObj, activity: 'CREATE', message: "WORK ASSIGNMENT SUCCESSFULLY" })
      this.spinner.hide();
      swal.fire("Success...", 'File Assigned Successfully', "success");
      // await this.getAllAccountWork('account');
      // if (this.activeTab == 'account') {
        await this.getAllAccountWork('account');
      // } else if (this.activeTab == 'computer') {
      //   await this.getAllComputerWork('computer');
      // } else if (this.activeTab == 'store') {
      //   await this.getAllStoreWork('store');
      // } else if (this.activeTab == 'all') {
      //   await this.getAllModuleWork('all');
      // }

      $('#work_assign').modal('hide');
      this.assignmentObj = {}
    } else {
      this.spinner.hide();
      swal.fire("Error", 'Error While File Assigning', "error");
    }
  }


  /******************************************************Approval Code Start********************************************* */

  undertakings: any
  salBill_apprdata: any
  async Appr(element: any) {
    await this.editorService.clearTetx();
    this.editorService.language='English'
    this.editorService.class_hindi=false
    this.forwarded_user_id=null;
    this.salBill_apprdata = Object.assign({}, element)
    this.salBill_apprdata['undertaking'] = ""
    this.salBill_apprdata['bill_desc'] = 'Approval for ' + element['work_order_no']
    this.salBill_apprdata['level'] = 1
    this.salBill_apprdata['branch'] = 1
    this.salBill_apprdata['doc_local_no'] = this.salBill_apprdata['work_id']
    this.salBill_apprdata['doc_type'] = "FILE";
    this.salBill_apprdata['node_cd'] = element.proj_cd;
    this.salBill_apprdata['module_cd'] = 'ACCOUNT';
    await this.ApprovalUserService.getWorkflowlog(this.erpUser, 'FILE', 'ACCOUNT');
    if (this.ApprovalUserService.workflow_level1 == undefined) {
      swal.fire('INFO', 'Please Create Workflow of type : ' + 'FILE', 'info')
      return;
    }
    await this.ApprovalUserService.getMostLatestWorkflowlog(this.erpUser, this.salBill_apprdata)
    await this.ApprovalUserService.getWorkflowloguser(this.erpUser, this.salBill_apprdata)
    $('#myModal3').modal('show');
  }
  message_flag = true
  async getle(user_id: any) {
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['le_id'] = user_id
    let resp = await this.poralMainService.getcurrentlegalentity(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "CURRENT LEGAL ENTITY RECEIVED SUCCESSFULLY" })
      //await this.updatepending(this.tender_apprdata)
      await this.sendmessage(resp['data'][0]['phone_no'], resp['data'][0]['party_name'])
      this.spinner.hide();
      // this.message_flag = false
      //this.toastr.successToastr("Approval Forwarded Successfully!!")
    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');
    }
  }

  async sendmessage(mobile: any, user_name: any) {
    let resp = await this.poralMainService.sendNotiMsg(mobile, this.salBill_apprdata['doc_type'], this.salBill_apprdata['doc_local_no'], user_name)
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'POST', message: "NOTIFICATION MESSAGE SENT SUCCESSFULLY" })
      this.spinner.hide();
    } else {
      this.spinner.hide();
      swal.fire("Error", resp['data'], 'error');
    }
  }


  forwarded_user_id: any;
  appr_remark: any = ""
  isResponseReceived: boolean = false;
  async Approvedapproval() {

    this.spinner.show()
    this.isResponseReceived = true
    let showError = false;
    if (!this.forwarded_user_id) {
      this.spinner.hide();
      swal.fire('Info', 'Please select User!', 'info');
     this.isResponseReceived=false
      return;
    }
    try {
      const parsed = JSON.parse(this.editorService.to_data);
      const textOnly = parsed.body
        .replace(/<!--[\s\S]*?-->/g, '') //invisble comment
        .replace(/&nbsp;/g, '')          //invisible spaces(&nbsp)  
        .replace(/<[^>]*>/g, '')         // Remove all the tags
        .trim();

      if (textOnly.length === 0) {
        showError = true;
      }

    } catch (error) {
      showError = true;
    }
    if (showError) {
      swal.fire('Info', 'Please write Notesheet!', 'info');
      this.spinner.hide();
      this.isResponseReceived=false
      return;
    }
    if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
      let obb: any = new Object();
      this.appr_remark = this.editorService.to_data
      obb['user_id'] = this.erpUser.user_id
      obb['b_acct_id'] = this.erpUser.b_acct_id
      obb['forwarded_by'] = null
      obb['forward_msg'] = this.appr_remark
      obb['remark'] = this.appr_remark
      obb['status'] = 'APPROVED'
      obb['doc_type'] = this.salBill_apprdata['doc_type']// 'PDI_BILL'
      obb['doc_local_no'] = this.salBill_apprdata['doc_local_no']
      obb['doc_desc'] = this.salBill_apprdata['bill_desc']
      obb['role_cd'] = this.ApprovalUserService.level1['role_cd']//this.level1['role_cd']
      obb['module_cd'] = this.salBill_apprdata['module_cd'] //'ACCOUNT'
      obb['node_cd'] = this.salBill_apprdata['node_cd']
      obb['level'] = this.ApprovalUserService.level1['level']
      obb['undertaking'] = this.salBill_apprdata['undertaking']
      obb['branch'] = this.ApprovalUserService.level1['branch']
      obb['user_name'] = this.erpUser.party_name;
      obb['language'] = this.editorService.language
      obb['field_value'] = 0



      let resp = await this.poralMainService.insertTask(obb)
      if (resp['error'] == false) {
        this.log.createLog({ ...this.logObj, activity: 'POST', message: "APPROVAL APPROVED AND FORWARDED SUCCESSFULLY" })
        await this.pendingapproval()

        await this.changeWorkStatus(this.salBill_apprdata.doc_local_no, 'UNDERAPPROVAL')
        // this.salBill_apprdata['doc_local_no'],this.salBill_apprdata['id'], 'UNDERAPPROVAL'
        await this.getAllAccountWork('account')
        this.spinner.hide();
        if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
          // obb['user_id'] = -1
          if (this.message_flag == true) {
            /* await this.getle(this.selectedTender['party_id']) */
          }

        } else {
          if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'])

        }
        this.toastr.success("Approval Forwarded Successfully!!");
        await this.editorService.clearTetx()
        this.forwarded_user_id=null;
        this.isResponseReceived=false;
       this.editorService.language='English'
       this.editorService.class_hindi=false
        $('#myModal3').modal('hide');

        // this.ListObj['jrnl_id'] = null;
      } else {
        this.spinner.hide();
        this.isResponseReceived = false;
        // this.toastr.errorToastr(resp['data'])
      }
    } else {
      this.isResponseReceived = false;
      // this.toastr.errorToastr("Please Select Any User..!")
      this.spinner.hide();
    }
  }


  async pendingapproval() {
    this.spinner.show()
    if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
      let obb: any = new Object();
      if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
      } else {
        obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
        obb['user_name'] = this.ApprovalUserService.userObj[this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']]
      }
      this.appr_remark = this.editorService.to_data
      obb['b_acct_id'] = this.erpUser.b_acct_id
      obb['forwarded_by'] = this.erpUser.user_id
      obb['forward_msg'] = this.appr_remark
      obb['remark'] = null
      obb['status'] = 'PENDING'
      obb['doc_type'] = this.salBill_apprdata['doc_type'] // 'PDI_BILL'
      obb['doc_local_no'] = this.salBill_apprdata['doc_local_no']
      obb['doc_desc'] = this.salBill_apprdata['bill_desc']
      obb['module_cd'] = this.salBill_apprdata['module_cd'] //'ACCOUNT'
      obb['node_cd'] = this.salBill_apprdata['node_cd']
      obb['undertaking'] = this.salBill_apprdata['undertaking']
      obb['language'] = this.editorService.language
      if (this.ApprovalUserService.vendorflag == true) {
        obb['level'] = this.salBill_apprdata['level']
        obb['branch'] = this.salBill_apprdata['branch']
      }
      else {
        obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
        obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
        obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
      }
      obb['field_value'] = 0
      let resp = await this.poralMainService.insertTask(obb)
      if (resp['error'] == false) {
        this.log.createLog({ ...this.logObj, activity: 'POST', message: "APPROVAL FOR " + this.salBill_apprdata['doc_local_no'] + " IS IN PENDING SUCCESSFULLY" })

        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    } else {
      this.spinner.hide();
    }
  }

  statusArr: any = [];
  selectedEle: any;
  userRoles: any = []

  async viewStatus(element: any) {
    this.selectedEle = Object.assign({}, element);
    let obj: any = new Object();
    obj['doc_local_no'] = element.work_id;
    obj['b_acct_id'] = this.erpUser.b_acct_id;
    // obj['doc_type'] = 'FILE';
    // obj['module_cd'] = 'ACCOUNT'
    obj['doc_type'] = element.doc_type;
    obj['module_cd'] = element.module_cd
    element.node_cd = element['proj_cd']


    let resp = await this.poralMainService.getWorkflowlog(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "WORK FLOW LOG RECEIVED SUCCESSFULLY" })
      this.salBill_apprdata = Object.assign({}, element)
      this.salBill_apprdata['level'] = 1
      this.salBill_apprdata['branch'] = 1
      this.salBill_apprdata['doc_local_no'] = this.salBill_apprdata['id']
      this.salBill_apprdata['doc_type'] = 'FILE'
      this.salBill_apprdata['node_cd'] = element.node_cd
      this.salBill_apprdata['module_cd'] = 'ACCOUNT';
      await this.getWorkflowloguser()
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]['user_id'] == -1) {
          resp.data[i]['name'] = "Contractor"
          resp.data[i]['role_cd'] = "Contractor"
          continue;
        }
        for (let j = 0; j < this.workflowuser.length; j++) {
          if (resp.data[i]['user_id'] == this.workflowuser[j]['user_id'] && resp.data[i]['role_cd'] == this.workflowuser[j]['role_cd']) {
            resp.data[i]['name'] = this.workflowuser[j]['emp_name']
            resp.data[i]['role_cd'] = this.workflowuser[j]['role_cd']
          }
        }
        if (resp.data[i]['name'] == undefined) {
          resp.data[i]['name'] = ''

        }
      }
      this.statusArr = resp.data
      $('#myModal1').modal('show');
    } else {
      this.toastr.error(resp['data'])
    }
  }
  selectedTender = {}
  workObj = {}
  workflowuser = []
  rolecdtolevelobj = {}
  async getWorkflowloguser() {
    let obj: any = new Object()
    obj['b_acct_id'] = this.b_acct_id
    obj['module_cd'] = this.salBill_apprdata['module_cd'] //'ACCOUNT'
    obj['status'] = 'ACTIVE'
    obj['node_cd'] = this.salBill_apprdata['node_cd']
    let resp = await this.poralMainService.getUsersForModuleWorkflow(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "USER FOR MODULE WORKFLOE RECEIVED SUCCESSFULLY" })
      this.spinner.hide();
      this.workflowuser = resp['data']

    } else {
      this.spinner.hide();
      this.toastr.error(resp['data'])
    }
  }
  /******************************************************Approval Code End*********************************************** */


  async print() {
    var txt = "File";
    var dd: any = {
      pageSize: "A4",
      header: function (currentPage: any, pageCount: any) {
        var arr = [];
        // var obj = {
        //   text: txt + "     Page No. - " + currentPage,
        //   alignment: "center",
        //   margin: [72, 40],
        //   fontSize: 15,
        //   bold: true,
        // };
        // arr.push(obj);
        var obj1 = {
          text: "File",
          alignment: "center",
          margin: [72, 40],
          fontSize: 15,
          bold: true,
        };
        arr.push(obj1);

        return arr;
      },
      footer: function (currentPage: any, pageCount: any) {
        var arr1 = []
        var obb1 = { text: new Date().toLocaleDateString('en-GB'), alignment: 'right', margin: [40, 40, 40, 40], fontSize: 6 }
        arr1.push(obb1)
        return arr1
      },
      pageOrientation: 'landscape',
      pageMargins: [50, 60, 40, 60],
      content: [],
    };
    var header1 = {
      columns: [
        {
          width: "*",
          text: "Firm Name :",

        },
        {
          width: "*",
          text: this.workDetailsObj['org_name']
        },
        {
          width: "*",
          text: "Firm GSTIN :",
          bold: true,
        },
        {
          width: "*",
          text: this.workDetailsObj['gst_no']
        },
        {
          width: "*",
          text: "Firm Email :",
          bold: true,
        },
        {
          width: "*",
          text: this.workDetailsObj['email']
        },
        {
          width: "*",
          text: "Firm Mobile No. :",
          bold: true,
        },
        {
          width: "*",
          text: this.workDetailsObj['mobile_no']
        },
      ],
    };
    var header2 = {
      columns: [
        {
          width: "*",
          // text: "Work Order No. :",
          text: "File Number :",
          bold: true,
        },
        {
          width: "*",
          text: this.workDetailsObj['work_id']
        },
        {
          width: "*",
          text: "File Description :",
          bold: true,
        },
        {
          width: "*",
          text: this.workDetailsObj['work_desc'],
        },
        {
          width: "*",
          text: "File Start Date :",
          bold: true,
        },
        {
          width: "*",
          text: new Date(this.workDetailsObj['work_start_dt']).toLocaleDateString(),
        },
        // {
        //   width: "*",
        //   text: "File End Date :",
        //   bold: true,
        // },
        // {
        //   width: "*",
        //   text: this.workDetailsObj['work_desc'],
        // },
        {
          width: "*",
          text: "File Amount:",
          bold: true,
        },
        {
          width: "*",
          text: '₹' + this.workDetailsObj['work_order_amt'],
        },
      ],
    };
    var header3 = {
      columns: [
        {
          width: "*",
          text: "Budget :",
          bold: true,
        },
        {
          width: "*",
          text: this.workDetailsObj['budget'],
        },
        {
          width: "*",
          text: "Project :",
          bold: true,
        },
        {
          width: "*",
          text: this.workDetailsObj['project'],
        },
        {
          width: "*",
          text: "Product :",
          bold: true,
        },
        {
          width: "*",
          text: this.workDetailsObj['product']
        },
        {
          width: "*",
          text: "Activity :",
          bold: true,
        },
        {
          width: "*",
          text: this.workDetailsObj['activity']
        },
      ],
    };

    dd.content.push({ text: " " });
    dd.content.push({
      canvas: [{ type: "line", x1: 0, y1: 0, x2: 1115, y2: 0, lineWidth: 0.5 }],
    });

    dd.content.push({ text: " " });
    dd.content.push(header1);
    dd.content.push({ text: " " });
    dd.content.push({
      canvas: [{ type: "line", x1: 0, y1: 0, x2: 1115, y2: 0, lineWidth: 0.5 }],
    });
    dd.content.push({ text: " " });

    dd.content.push(header2);

    dd.content.push({ text: " " });
    dd.content.push({
      canvas: [{ type: "line", x1: 0, y1: 0, x2: 1115, y2: 0, lineWidth: 0.5 }],
    });
    dd.content.push({ text: " " });

    dd.content.push(header3);


    /**************************************** Workflow Log ********************************* */
    pdfMake.createPdf(dd).download("file.pdf");
  }


}
